import React from "react";
import { Card, Row, Col, Button } from "antd";

const DownloadPrescription = ({ pdfData }) => {
  return (
    <div style={{ padding: "20px" }}>
      <div id="pdf-content" style={{ width: "210mm", padding: "20px" }}>
        <Card>
          <Row>
            <Col span={24} style={{ textAlign: "center" }}>
              <h2>Quest Care Medical Clinic {pdfData}</h2>
              <p>Anand Society, Dindayal Road, Ghaklcipar</p>
              <p>Mumbai, 368585. Ph: 08097700800</p>
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Col span={12}>
              <strong>Patient:</strong>
              <p>Aakruti Kapoor</p>
              <p>Female, 31 years</p>
              <p>8097700069</p>
              <p>Date: 01-05-2019</p>
            </Col>
            <Col span={12} style={{ textAlign: "right" }}>
              <strong>Doctor:</strong>
              <p>Mr. Anil Kumar Sharma</p>
              <p>M.D.S (Pune)</p>
              <p>Registration No: A-77363</p>
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Col span={24}>
              <h3>Rx</h3>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  marginTop: "10px",
                }}
              >
                <thead>
                  <tr>
                    <th style={{ border: "1px solid black", padding: "8px" }}>
                      Medicine
                    </th>
                    <th style={{ border: "1px solid black", padding: "8px" }}>
                      Dosage
                    </th>
                    <th style={{ border: "1px solid black", padding: "8px" }}>
                      Duration
                    </th>
                    <th style={{ border: "1px solid black", padding: "8px" }}>
                      Measure
                    </th>
                    <th style={{ border: "1px solid black", padding: "8px" }}>
                      Instructions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ border: "1px solid black", padding: "8px" }}>
                      Tab Rantac 150mg
                    </td>
                    <td style={{ border: "1px solid black", padding: "8px" }}>
                      1-1-1
                    </td>
                    <td style={{ border: "1px solid black", padding: "8px" }}>
                      3 days
                    </td>
                    <td style={{ border: "1px solid black", padding: "8px" }}>
                      After Meal
                    </td>
                    <td style={{ border: "1px solid black", padding: "8px" }}>
                      After Meal
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid black", padding: "8px" }}>
                      CAP SM FIBRO
                    </td>
                    <td style={{ border: "1px solid black", padding: "8px" }}>
                      1-0-1
                    </td>
                    <td style={{ border: "1px solid black", padding: "8px" }}>
                      5 days
                    </td>
                    <td style={{ border: "1px solid black", padding: "8px" }}>
                      After Meal
                    </td>
                    <td style={{ border: "1px solid black", padding: "8px" }}>
                      Instructions in Local Language
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Col span={24}>
              <strong>Remarks:</strong>
              <p>Keep measuring body temp. twice a day.</p>
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Col span={12}></Col>
            <Col span={12} style={{ textAlign: "right" }}>
              <p>Authorized Signature</p>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
};

export default DownloadPrescription;
